// Generated from D:/PJ/ieum/ieum-auto/apps/realtorauto-web/components/realtorauto/RealtorAutoNoticeDialogs.tsx
// Source SHA-256: 6699f2cd342aa5529999dabca2a128c9175f409f9367091d1dc423495df790f8
// 원본 RealtorAuto 편집기 동기화 파일입니다. 직접 수정하지 말고 syncRealtorAutoOriginalTemplateEditor.cjs를 실행하세요.
import { Loader2, Save } from "lucide-react";
export function RealtorAutoTemplateUnsavedNavigationDialog({
  open,
  versionName,
  saving,
  canSave,
  onVersionNameChange,
  onCancel,
  onDiscard,
  onSave
}) {
  if (!open) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/45 px-4 py-6" data-template-unsaved-modal>
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-5 shadow-xl">
        <div className="text-base font-black text-slate-950">저장하시겠습니까?</div>
        <p className="mt-2 text-sm leading-6 text-slate-500">
          현재 템플릿에 저장하지 않은 변경사항이 있습니다. 저장하려면 버전 이름을 입력하고 저장하세요.
        </p>
        <label className="mt-4 grid gap-1 text-xs font-bold text-slate-600">
          버전 이름
          <input value={versionName} onChange={event => onVersionNameChange(event.target.value)} className="h-10 rounded-lg border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-900 outline-none focus:border-blue-400" placeholder="예: 계약 문구 수정" autoFocus data-template-unsaved-version-name />
        </label>
        <div className="mt-5 flex flex-wrap justify-end gap-2">
          <button type="button" onClick={onCancel} className="inline-flex h-10 items-center justify-center rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 hover:bg-slate-50">
            계속 편집
          </button>
          <button type="button" onClick={onDiscard} className="inline-flex h-10 items-center justify-center rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 hover:bg-slate-50">
            아니오
          </button>
          <button type="button" onClick={() => void onSave()} disabled={!canSave || saving} className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-blue-700 px-4 text-sm font-semibold text-white hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-60">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden /> : <Save className="h-4 w-4" aria-hidden />}
            저장하기
          </button>
        </div>
      </div>
    </div>;
}
